import styled from "styled-components";
import {LobbyHeaderTitleDefaultBox} from "./lobby-header-title.default.box";

export const LobbyHeaderTitleMrGreenBox = styled(LobbyHeaderTitleDefaultBox)`
    font-size: 2rem;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        font-size: 2rem;
    }
`;
